class LazyImg {
  constructor(obj, src, onLoad, onError) {
    this.el = obj;
    this.url = src;
    this.onLoad = onLoad;
    this.onError = onError;
    this.load();
  }

  load() {
    this.loadImg(this.url)
      .then((node) => {
        const replaced = this.replace(node);
        this.el = replaced;
        return typeof this.onLoad === 'function' && this.onLoad(replaced);
      })
      .catch((error) => {
        return typeof this.onError === 'function' && this.onError(error);
      });
  }

  loadImg(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve(img);
      };
      img.onerror = () => {
        reject(new Error(`load error:${url}`));
      };
      img.src = url;
    });
  }

  replace(node) {
    const el = node;
    if (this.el.parentNode) {
      this.el.parentNode.replaceChild(node, this.el);
    }
    return el;
  }
}
export default LazyImg;
